<div class="filter-group" data-group-visibility-id="showGearCraftingBasesHighlights">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showGearCraftingBasesHighlights" (click)="filter.groupVisibility.showGearCraftingBasesHighlights = !filter.groupVisibility.showGearCraftingBasesHighlights; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Crafting Bases" [activeRules]="activeRules.craftingBaseFiltersPoe2">
          For any 'Favourite Gear' rules you specified, the filter will automatically highlight Exceptional variants. Here you can additionally highlight Exceptional items of <i>all</i> types.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showGearCraftingBasesHighlights) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showGearCraftingBasesHighlights">

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentExceptionalQualityGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentExceptionalQualityGear" (click)="toggleHighlightExcellentExceptionalQualityGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'Excellent Quality Gear' : 'Excellent Exceptional Quality Gear'" [additionalContent]="excellentExceptionalQualityGearPreview" ruleId="gear-exceptional-excellent-quality">
            <strong>Excellent Items</strong> are <app-gear-tier-icon [tier]="filter.showExcellentExceptionalQualityGearMinBaseTypeTier"></app-gear-tier-icon> {{ filter.showExcellentExceptionalQualityGearMinBaseTypeTier === BaseTypeTier.Elite ? 'Elite' : 'Advanced' }} items with at least {{ filter.showExcellentExceptionalQualityGearMinQuality ?? 28 }} Quality.
            <br /><strong>Good Items</strong> are <app-gear-tier-icon [tier]="filter.showGoodExceptionalQualityGearMinBaseTypeTier"></app-gear-tier-icon> {{ filter.showGoodExceptionalQualityGearMinBaseTypeTier === BaseTypeTier.Elite ? 'Elite' : 'Advanced' }} items with at least {{ filter.showGoodExceptionalQualityGearMinQuality ?? 21 }} Quality.

            <ng-template #excellentExceptionalQualityGearPreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearExcellentExceptionalQuality"
                [active]="filter.showExcellentExceptionalQualityGear"
                exampleName="Exceptional Gemini Bow"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodExceptionalQualityGear"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherGearGoodExceptionalQuality"
            exampleName="Exceptional Gemini Bow"
            [disabledWhen]="!filter.showExcellentExceptionalQualityGear"></app-filter-checkbox-group>
          <span class="sep"></span>
          <button class="btn toggle-button show-filters-button" [class.active]="showExceptionalQualityGearFilters" [disabled]="!filter.showExcellentExceptionalQualityGear"
            (click)="showExceptionalQualityGearFilters = !showExceptionalQualityGearFilters">
            <span class="icon icon-equalizer"></span>
          </button>
        </span>
      </div>

      @if (showExceptionalQualityGearFilters) {
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span class="filter-title" [class.disabled]="!filter.showExcellentExceptionalQualityGear">Min Gear Tier</span>
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.showExcellentExceptionalQualityGear">Excellent</div>
            <span class="sep"></span>
            <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showExcellentExceptionalQualityGear"
              [(ngModel)]="filter.showExcellentExceptionalQualityGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.showGoodExceptionalQualityGear">Good</div>
            <span class="sep"></span>
            <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showGoodExceptionalQualityGear"
              [(ngModel)]="filter.showGoodExceptionalQualityGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
          </span>
        </div>
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span class="filter-title" [class.disabled]="!filter.showExcellentExceptionalQualityGear">Min Quality</span>
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.showExcellentExceptionalQualityGear">Excellent</div>
            <span class="sep"></span>
            <input type="number" placeholder="28" min="1" max="100" inputmode="numeric" class="form-control minmax" style="min-width: 50px; width: 50px;"
              [disabled]="!filter.showExcellentExceptionalQualityGear" [(ngModel)]="filter.showExcellentExceptionalQualityGearMinQuality" (change)="updateFilter()">
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.showGoodExceptionalQualityGear">Good</div>
            <span class="sep"></span>
            <input type="number" placeholder="24" min="1" max="100" inputmode="numeric" class="form-control minmax" style="min-width: 50px; width: 50px;"
              [disabled]="!filter.showGoodExceptionalQualityGear" [(ngModel)]="filter.showGoodExceptionalQualityGearMinQuality" (change)="updateFilter()">
          </span>
        </div>
      }

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentExceptionalSocketedGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentExceptionalSocketedGear" (click)="toggleHighlightExcellentExceptionalSocketedGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'Exceptional Socketed Gear' : 'Excellent Exceptional Socketed Gear'" [additionalContent]="excellentExceptionalSocketedGearPreview" ruleId="gear-exceptional-excellent-socketed">
            <strong>Excellent Items</strong> are <app-gear-tier-icon [tier]="filter.showExcellentExceptionalSocketedGearMinBaseTypeTier"></app-gear-tier-icon> {{ filter.showExcellentExceptionalSocketedGearMinBaseTypeTier === BaseTypeTier.Elite ? 'Elite' : 'Advanced' }} items with an extra socket.
            <br /><strong>Good Items</strong> are <app-gear-tier-icon [tier]="filter.showGoodExceptionalSocketedGearMinBaseTypeTier"></app-gear-tier-icon> {{ filter.showGoodExceptionalSocketedGearMinBaseTypeTier === BaseTypeTier.Elite ? 'Elite' : 'Advanced' }} items with an extra socket. Boots, Gloves and Foci with 2 sockets are always considered at least good, regardless of the base type tier.

            <ng-template #excellentExceptionalSocketedGearPreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearExcellentExceptionalSocketed"
                [active]="filter.showExcellentExceptionalSocketedGear"
                exampleName="Exceptional Ancestral Tiara"
                sockets="WW"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodExceptionalSocketedGear"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherGearGoodExceptionalSocketed"
            exampleName="Exceptional Jungle Tiara"
            sockets="WW"
            [disabledWhen]="!filter.showExcellentExceptionalSocketedGear"></app-filter-checkbox-group>
          <span class="sep"></span>
          <button class="btn toggle-button show-filters-button" [class.active]="showExceptionalSocketedGearFilters" [disabled]="!filter.showExcellentExceptionalSocketedGear"
            (click)="showExceptionalSocketedGearFilters = !showExceptionalSocketedGearFilters">
            <span class="icon icon-equalizer"></span>
          </button>
        </span>
      </div>

      @if (showExceptionalSocketedGearFilters) {
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span class="filter-title" [class.disabled]="!filter.showExcellentExceptionalSocketedGear">Min Gear Tier</span>
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.showExcellentExceptionalSocketedGear">Excellent</div>
            <span class="sep"></span>
            <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showExcellentExceptionalSocketedGear"
              [(ngModel)]="filter.showExcellentExceptionalSocketedGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.showGoodExceptionalSocketedGear">Good</div>
            <span class="sep"></span>
            <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showGoodExceptionalSocketedGear"
              [(ngModel)]="filter.showGoodExceptionalSocketedGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
          </span>
        </div>
      }

      <div class="filter filter-property full-span" [class.disabled]="!filter.showILevel82NormalGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showILevel82NormalGear" (click)="toggleHighlightILevel82NormalGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'iLevel 82 Gear' : 'iLevel 82 Normal Gear'" [additionalContent]="iLevel82NormalGearPreview" ruleId="gear-crafting-bases-ilevel-82">
            <ng-template #iLevel82NormalGearPreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearILevel82"
                [active]="filter.showILevel82NormalGear"
                exampleName="Gemini Bow"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showILevel82NormalGear"
            [(ngModel)]="filter.showILevel82NormalGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showILevel81NormalGear"
            labelText="iLevel 81"
            [equipmentType]="EquipmentType.OtherGearILevel81"
            exampleName="Gemini Bow"
            [disabledWhen]="!filter.showILevel82NormalGear"></app-filter-checkbox-group>
          <span class="sep"></span>
          <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showILevel81NormalGear"
            [(ngModel)]="filter.showILevel81NormalGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showHighILevelCharms">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showHighILevelCharms" (click)="toggleHighlightHighILevelCharms()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'High iLevel Charms' : 'High iLevel Normal Charms'" [additionalContent]="highILevelCharmsPreview" ruleId="charms-high-ilevel">
            <ng-template #highILevelCharmsPreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherCharmsILevel"
                [active]="filter.showHighILevelCharms"
                exampleName="Golden Charm"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'All'"
            [options]="charmBaseTypes"
            [disabled]="!filter.showHighILevelCharms"
            [showOptions]="true"
            [selectedValues]="filter.showHighILevelCharmTypes || ['All']"
            (selectedValuesChange)="filter.showHighILevelCharmTypes = $event; updateFilter();"></app-autocomplete>
          <span class="sep"></span>
          <input type="number" placeholder="Min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showHighILevelCharms"
            [(ngModel)]="filter.showHighILevelCharmsMinILevel" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentJewelleryBaseTypes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentJewelleryBaseTypes" (click)="toggleHighlightExcellentJewelleryBaseTypes()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Jewellery' : 'Excellent Jewellery' }}" [additionalContent]="excellentJewelleryBaseTypesStylePreview" ruleId="jewellery-crafting-bases-excellent-base-types">
            Highlights Excellent and Good <span class="normal-item-color">Normal</span> Jewellery Base Types, optionally of the specified minimum item level.
            <br /><br /><strong>Excellent</strong>: {{ excellentJewelleryBaseTypes.join(', ') }}
            <br /><strong>Good</strong>: {{ goodJewelleryBaseTypes.join(', ') }}
            <br /><br />You can specify which Jewellery Base Types are Excellent and Good in the <a href="/tier-list/jewellery">Jewellery Tier List</a> tab.
            <br /><br />Bases that cannot drop as <span class="normal-item-color">Normal</span> are covered by the Special Jewellery rules in the Special Equipment group below.
            <ng-template #excellentJewelleryBaseTypesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryExcellentBaseTypes"
                [alignLeft]="true"
                [active]="filter.showExcellentJewelleryBaseTypes"
                exampleName="{{ excellentJewelleryBaseTypes[0] || 'Gold Amulet' }}"
                [rarity]="Rarity.Normal"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentJewelleryBaseTypes"
            [(ngModel)]="filter.showExcellentJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodJewelleryBaseTypes"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherJewelleryGoodBaseTypes"
            [exampleName]="goodJewelleryBaseTypes[0] || 'Gold Amulet'"
            [disabledWhen]="!filter.showExcellentJewelleryBaseTypes"></app-filter-checkbox-group>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showGoodJewelleryBaseTypes"
            [(ngModel)]="filter.showGoodJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
